// themes.js
export const theme = {
    inputContainerBackground: "#2B2D39",
    inputContainerBorder: "#454650",
    inputTextColor: "#fff",
    inputPlaceholderTextColor: "#6F7080",

    inputDisabledContainerBackground: "#2B2D39",
    inputDisableTextColor: "#7F818D",

    checkboxColor: "#4378FF",
    checkMarkColor: "#fff",

    selectBackgroundColor: "#333443",
    selectTextColor: "#4378FF",
    selectArrowColor: "#4378FF",
    selectShadowColor: "rgba(0, 0, 0, 0.25)",
    selectScrollBarColor: "#333443",
    selectScrollThumbColor: "rgba(10, 10, 10, 0.2)",
    selectWrapperOptionBackgroundColor: "#333443",
    selectOptionBackgroundHovererColor: "#414250",
    selectOptionTextColor: "#4378FF",

    mainButtonBackgroundColor: '#3C6CE6',
    mainButtonTextColor: '#fff',
    mainButtonDisabledBackgroundColor: '#6F7080',
    mainButtonDisabledTextColor: '#333443',

    cancelButtonBackgroundColor: '#333443',
    cancelButtonTextColor: '#4C89FE',
    cancelButtonDisabledBackgroundColor: '#7F818D',

    blockButtonBackgroundColor: '#333443',
    blockButtonTextColor: '#4C89FE',
    blockButtonDisabledBackgroundColor: '#333443',

    transparentButtonTextColor: '#4C89FE',
};
